var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "modify-password-dialog",
      attrs: {
        title: _vm.$t("myResources.main_CHANGE_PASSWORD_TOOLTIP"),
        visible: _vm.innerVisible,
        "custom-classs": "modify-password-dialog",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        width: "380px",
        "append-to-body": ""
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "el-form",
        { attrs: { inline: "", "label-width": _vm.isZh ? "100px" : "180px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("myResources.password_oldPassword") } },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.oldPwd,
                  callback: function($$v) {
                    _vm.oldPwd = $$v
                  },
                  expression: "oldPwd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("myResources.password_newPassword") } },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.newPwd,
                  callback: function($$v) {
                    _vm.newPwd = $$v
                  },
                  expression: "newPwd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("myResources.password_confirmTheNewPassword")
              }
            },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.confirmPwd,
                  callback: function($$v) {
                    _vm.confirmPwd = $$v
                  },
                  expression: "confirmPwd"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("p", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v(_vm._s(_vm.passwordMessage))
      ]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("myResources.CANCEL")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.modifyPwd } },
            [_vm._v(_vm._s(_vm.$t("myResources.OK")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }